import { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { Container, useMediaQuery } from '@mui/material'
import Grid from '@mui/material/Grid'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Slider from 'react-slick'
import { useProducts } from '../../context/Products/ProductsContext'
import Spinner from '../../containers/Spinner/Spinner'
import { formatter } from '../../utils/auxFunc'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './Home.css'

function SampleNextArrowCategories(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', marginRight: '15px' }}
      onClick={onClick}
    />
  )
}

function SamplePrevArrowCategories(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', marginLeft: '15px' }}
      onClick={onClick}
    />
  )
}

var settingsCategories = {
  // dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 9, //cuantos productos quiero mostrar en pantalla
  slidesToScroll: 9, //de a cuantos productos quiero que se vengan
  initialSlide: 0, //en la pagina que quiero que se inicialice
  nextArrow: <SampleNextArrowCategories />,
  prevArrow: <SamplePrevArrowCategories />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
        infinite: true
        // dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
        initialSlide: 0
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0
      }
    },
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0
      }
    }
  ]
}

function SampleNextArrowBanners(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{ ...style, display: 'none' }}
      onClick={onClick}
    />
  )
}

function SamplePrevArrowBanners(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{ ...style, display: 'none' }}
      onClick={onClick}
    />
  )
}

const settingsBanners = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  nextArrow: <SampleNextArrowBanners />,
  prevArrow: <SamplePrevArrowBanners />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0
      }
    }
  ]
}

function Home({ auth, products, banners }) {
  const { categories } = useProducts()
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.up('md'))

  function slideChoice(banner) {
    const { idProduct, img, category, description } = banner

    if (idProduct !== '' && category === '') {
      return (
        <Link to={`/itemDetail/${idProduct}`} target="_blank">
          <img className="imgBanner" src={img} alt={description} />
        </Link>
      )
    } else if (idProduct === '' && category !== '') {
      return (
        <Link to={`/category/${category.toLowerCase()}`} target="_blank">
          <img className="imgBanner" src={img} alt={description} />
        </Link>
      )
    } else {
      return <img className="imgBanner" src={img} alt={description} />
    }
  }

  return products ? (
    <Fragment>
      <Slider {...settingsBanners}>
        {banners?.map((banner) => (
          <div key={banner.idBanner}>{slideChoice(banner)}</div>
        ))}
      </Slider>

      <Container>
        <Typography
          sx={{
            textAlign: 'left',
            fontFamily: 'Quicksand',
            fontWeight: 'bold',
            mt: 2,
            pb: 2,
            pt: 2
          }}
        >
          Categorías
        </Typography>
        <center>
          <Slider {...settingsCategories}>
            {categories?.map((category) => (
              <div key={category.idCategory}>
                <Link to={category.routeURL}>
                  <img
                    className="imgCategories"
                    src={category.imageURL}
                    alt={category.name}
                  />
                </Link>
                <Typography
                  className={
                    isSmallScreen ? 'nameCategoryLarge' : 'nameCategorySmall'
                  }
                >
                  {category.name}
                </Typography>
              </div>
            ))}
          </Slider>
        </center>
        <Box component="main" className="imgGridContainer" mb={4}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                textAlign: 'left',
                fontFamily: 'Quicksand',
                fontWeight: 'bold',
                fontSize: '1.2rem',
                pb: 2
              }}
            >
              Lo Más Vendido
            </Typography>
            <Typography
              sx={{
                textAlign: 'left',
                fontFamily: 'Quicksand',
                pb: 2
              }}
            >
              Ver todos
            </Typography>
          </Box>
          <Grid container spacing={2}>
            {products?.map((product) => (
              <Grid
                className="gridContainer"
                key={product.idProduct}
                item
                xs={6}
                md={3}
                mb={4}
              >
                <Link
                  className="linkGridHome"
                  to={`/itemDetail/${product.idProduct}`}
                >
                  <CardMedia
                    className="imgGrid"
                    component="img"
                    image={product.img}
                    alt={product.name}
                  />
                  <Typography
                    className="nameCard"
                    sx={{ textAlign: 'left' }}
                    variant="body1"
                    style={{ fontFamily: 'Quicksand' }}
                  >
                    {product.name}
                  </Typography>
                  <Typography
                    className="nameCard"
                    sx={{ textAlign: 'left' }}
                    variant="body1"
                    style={{ fontFamily: 'Quicksand' }}
                  >
                    {`SKU: ${product.sku}`}
                  </Typography>

                  {!product.isPromotion ? (
                    <Typography
                      sx={{
                        textAlign: 'left',
                        fontWeight: 'bold',
                        mb: 3.5
                      }}
                      color="text.primary"
                      variant="h3"
                    >
                      {auth &&
                        formatter().format(product.price * product.dolarValue)}
                    </Typography>
                  ) : (
                    <Box className="price-box-home">
                      <Typography
                        sx={{
                          textAlign: 'left',
                          fontWeight: 'bold',
                          mb: 3.5
                        }}
                        color="text.primary"
                        variant="h3"
                        className="price-home"
                      >
                        {/* {auth &&
                          formatter().format(
                            Boolean(product.voidedPrice)
                              ? product.voidedPrice * product.dolarValue
                              : (1 + product.priceIncreasePercentage) *
                                  (product.price * product.dolarValue)
                          )} */}
                        {auth &&
                          formatter().format(
                            product.markedPrice * product.dolarValue
                          )}
                      </Typography>
                      <Typography
                        sx={{
                          textAlign: 'left',
                          fontWeight: 'bold',
                          mb: 3.5,
                          ml: 2
                        }}
                        color="red"
                        variant="h3"
                      >
                        {auth &&
                          formatter().format(
                            product.price * product.dolarValue
                          )}
                      </Typography>
                    </Box>
                  )}
                </Link>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Fragment>
  ) : (
    <Spinner />
  )
}

export default Home
